<div class="my-search-wrapper">
  <div class="my-search-controls" *ngIf="selectedSearch$ | async as selectedSearch">
    <rlst-action-dropdown itemLabel="Saved Searches"
                          [itemList]="mySearchList"
                          [defaultActionName]="defaultActionName"
                          [currentItem]="selectedSearch"
                          (defaultAction)="openEditSearchModal(true)"
                          (itemAction)="openMySearch($event)">
    </rlst-action-dropdown>
    <div class="mat-expansion-panel-header-title text-black saved-search-selected">{{ savedSearchSelected }}</div>
    <div class="d-flex justify-content-between customize-and-save">
      <button type="button" (click)="openEditSearchModal()" class="btn-custom btn-custom-sm btn-custom-outline-dark">
        <i class="far fa-exchange pr-2" aria-hidden="true"></i>
        Customize Search
      </button>
      <button type="button"
              class="btn-custom btn-custom-sm btn-custom-dark my-search-save"
              (click)="save()"
              [disabled]="(selectedSearch$ | async).inherited || !mySearchForm.valid">
        <i class="far fa-save" aria-hidden="true"></i>
        <span class="pr-3"> Save </span>
      </button>
    </div>
  </div>
  <form class="h-100 d-flex flex-column"
        [formGroup]="mySearchForm"
        (ngSubmit)="search()"
        autocomplete="off"
        novalidate>
    <div class="search-form-wrapper">
      <ng-container *ngIf="this.mapShapes$ | async as mapShapes">
        <rlst-expandable-item *ngIf="mapShapes.length"
                              [title]="'Map Tools Applied'"
                              [expanded]="true">
          <div *ngFor="let shape of mapShapes" class="w-100 position-relative shape">
            <span>{{shape.name}}</span>
            <div class="position-absolute shape-actions">
              <a role="button" class="btn btn-icon far fa-trash-alt trash-icon"
                 (click)="removeShape(shape)">
                <span class="sr-only">Remove search item</span>
              </a>
            </div>
          </div>
          <span class="w-100 d-block max-shapes" *ngIf="mapShapes.length === 5">5 shapes maximum.</span>
        </rlst-expandable-item>
      </ng-container>
      <ng-container>
        <rlst-premium-map *ngIf="(isPremiumLayerWorks$ | async)"
                          [template]="premiumMapTemplate"
                          [disabled]="!(isSingleCounty$ | async)"
                          [disabledMessage]="((premiumMinScaleExceeded$ | async) && (isSingleCounty$ | async))
                            ? 'Zoom in for premium map layers'
                            : !(isSingleCounty$ | async)
                              ? 'Select only one county for premium map layers'
                              : ''"
                          (toggleVal)="onSelectPremiumOption($event)">
        </rlst-premium-map>
      </ng-container>
      <ng-container *ngFor="let searchField of searchFields$ | async">
        <rlst-search-form-list
          *ngIf="searchField.fieldCode !== FieldCode.MAP && { crossField: getSearchFieldExpanded(searchField) } as crossCheck"
          [formArrayName]="searchField.fieldCode"
          [searchList]="mySearchForm.get(searchField.fieldCode)"
          [dataElement]="searchField"
          [expanded]="crossCheck.crossField"
          [disabled]="!crossCheck.crossField"
          [disabledMessage]="!crossCheck.crossField ? 'This SearchField is not allowed with the selected premium search layer' : ''"
          [defaultOperatorValueList]="defaultOperatorValueListMap[searchField.fieldCode]"
          (operatorValueChanged)="onOperatorValueChanged($event, searchField)"
          (fieldAdded)="onFieldAdded($event, searchField)">
        </rlst-search-form-list>
      </ng-container>
    </div>

    <div class="search-controls">
      <button type="reset" class="btn btn-primary clear-all btn-lg" (click)="clearSearch($event)">
        Clear All
      </button>
      <button type="submit" class="btn-custom btn-custom-dark ml-5 search-btn btn-lg"
        [disabled]="(isFormValid$ | async) === false || (isFormEmpty$ | async)">
        Search
      </button>

      <div class="pagination-container">
        <ng-content select=".js-grid-pagination"></ng-content>
      </div>
    </div>
  </form>
</div>
